import * as React from 'react';

function SvgCullinanCaretDown(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <path d="M6 8l4 4 4-4H6z" fill="currentColor" />
    </svg>
  );
}

const ForwardRef = React.forwardRef(SvgCullinanCaretDown);
export default ForwardRef;
